module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Lucky_01.0d9d51d8.png";